<template>
  <!-- START - We recommend to place the below code where you want the form in your website html  -->
  <div class="sib-form no-p mt-2" style="text-align: center;">
    <div id="sib-form-container" class="sib-form-container">
      <div id="error-message" class="sib-form-message-panel" style="font-size:16px; text-align:left; color:#000000; background-color:#ffeded; border-radius:3px; border-color:#ff4949;max-width:540px;">
        <div class="sib-form-message-panel__text sib-form-message-panel__text--center">
          <svg viewBox="0 0 512 512" class="sib-icon sib-notification__icon">
            <path d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z" />
          </svg>
          <span class="sib-form-message-panel__inner-text">
                          Your subscription could not be saved. Please try again.
                      </span>
        </div>
      </div>
      <div></div>
      <div id="success-message" class="sib-form-message-panel" style="font-size:12px; text-align:center; color:#ffffff; background-color:#2e4f9c; border-radius:3px; border-color:#8bcfcf;max-width:540px;">
        <div class="sib-form-message-panel__text sib-form-message-panel__text--center">
          <svg viewBox="0 0 512 512" class="sib-icon sib-notification__icon">
            <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z" />
          </svg>
          <span class="sib-form-message-panel__inner-text">
                          Your subscription has been successful.
                      </span>
        </div>
      </div>
      <div></div>
      <div id="sib-container" class="sib-container--large sib-container--horizontal" style="text-align:center; background-color:#F5F5EFFF; border-radius:25px; border-width:0px; border-color:#C0CCD9; border-style:solid; direction:ltr">
        <form id="sib-form" method="POST" action="https://sibforms.com/serve/MUIFAPKJP59yZrxINKrq3TwolBJ-q5dAz2cQEZzsD4WabNm6GRvl1LCfRmc0Y23pN9i3q-XifqWyMD9GEWNlZeCRqMo0eLJasJjoeYzu_64scOZcda93cHkkbBntwnvgt2eB_cq8tv2PwsuObrUK5F630FtjHHCRs8x5t9szGZhuGCLFv0qNDkjZ0ftgheC6AwghHWau_GP47hnA" data-type="subscription">
          <div class="row mt-1 mb-1">
            <div class="sib-form-block mt-05 basis-30-gap-1 blue col align-self-end" style="background-color:transparent; text-align:left">
              <img src="../assets/img/icon_newsletter.png" class="drawing">
              <h4 class="no-p">Red + Blue <span class="italic thin">attempt</span> <br>at a newsletter</h4>
            </div>

            <div class=" basis-70-gap-1 col justify-content-center">
              <div>
                <div class="sib-form-block" style="font-size:16px; text-align:left; color:#2e4f9c; background-color:transparent; text-align:left">
                  <div class="sib-text-form-block">
                    <p>We’ve been wanting to run a newsletter for a while, but never have found the time... until now? How long are we gonna last...? Subscribe to find out and get new release & workshop updates! </p>
                  </div>
                </div>
              </div>
              <div>
                <div class="sib-input sib-form-block">
                  <div class="form__entry entry_block">
                    <div class="form__label-row form__label-row--horizontal">

                      <div class="entry__field">
                        <input class="input " type="text" id="EMAIL" name="EMAIL" autocomplete="off" placeholder="Email" data-required="true" required />
                      </div>
                    </div>

                    <label class="entry__error entry__error--primary" style="font-size:16px; text-align:left; color:#000000; background-color:#ffeded; border-radius:3px; border-color:#ff4949;">
                    </label>
                  </div>
                </div>
              </div>
              <div>
                <div class="sib-form-block" style="text-align: center">
                  <button class="dark sib-form-block__button sib-form-block__button-with-loader no-m" form="sib-form" type="submit">
                    <svg class="icon clickable__icon progress-indicator__icon sib-hide-loader-icon" viewBox="0 0 512 512">
                      <path d="M460.116 373.846l-20.823-12.022c-5.541-3.199-7.54-10.159-4.663-15.874 30.137-59.886 28.343-131.652-5.386-189.946-33.641-58.394-94.896-95.833-161.827-99.676C261.028 55.961 256 50.751 256 44.352V20.309c0-6.904 5.808-12.337 12.703-11.982 83.556 4.306 160.163 50.864 202.11 123.677 42.063 72.696 44.079 162.316 6.031 236.832-3.14 6.148-10.75 8.461-16.728 5.01z" />
                    </svg>
                    Subscribe
                  </button>
                </div>
              </div>
            </div>
          </div>
          <input type="text" name="email_address_check" value="" class="input--hidden">
          <input type="hidden" name="locale" value="en">
        </form>
      </div>
    </div>
  </div>

  <!--  <div v-if="!success" class="col">-->
  <!--        <input class="newsletter" type="email" id="email" name="email" placeholder="Your email" v-model="emailCollected"/>-->
  <!--        <button class="dark full " @click="requestSubscription">Subscribe</button>-->
  <!--        <p class="red no-m">{{error}}</p>-->
  <!--      </div>-->
  <!--      <div v-else class="centered">-->
  <!--        <h4>You are subscribed! :)</h4>-->
  <!--        <button v-if="backToWebsite" class="dark" @click="goHome()"> back to website</button>-->
  <!--        <p v-if="!backToWebsite" class="mb-1"></p>-->
  <!--      </div>-->
</template>

<script>
import router from "@/router/index.js";

export default {
  name: "NewsletterSignupBlock",
  props: ['backToWebsite'],
  data() {
    return {
      emailCollected: '',
      success: false,
      error: '',
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

input.newsletter {
  padding: 1em;
  font-size: 1em;
  border-radius: 20px;
  border: 1px $blue solid;
}

#sib-container input:-ms-input-placeholder {
  text-align: left;
  font-family: Poppins, sans-serif;
  color: #c0ccda;
}

#sib-container input::placeholder {
  text-align: left;
  font-family: Poppins, sans-serif;
  color: #c0ccda;
}

#sib-container textarea::placeholder {
  text-align: left;
  font-family: Poppins, sans-serif;
  color: #c0ccda;
}

#sib-container a {
  text-decoration: underline;
  color: #2BB2FC;
}

#sib-form {
  font-family: Poppins, 'sans-serif';
}

.sib-form-block, p {
  font-family: Poppins, 'sans-serif';
  line-height: 125%;
  font-size: 1em;
}

#sib-container input {
  padding: .8em;
  font-size: 1em;
  border-radius: 20px;
}

.entry__field {
  border-radius: 20px;
}

.sib-form-block__button {
  padding: 1rem 4rem;
  line-height: 1.9rem;
  width: 100%;
  margin: 0.5rem 0 1rem 0;
}

@media only screen and (max-width: 747px) {
  .sib-text-form-block {
    margin-top: 1em;
  }
}
</style>